import GestionProveedores from "../../components/GestionProveedores";
const GestionProveedoresPage = () => <GestionProveedores />;
export default GestionProveedoresPage;
